import React from 'react';
import ReactTable from 'react-table';
import Pagination from '../../../components/common/Pagination';

export default class PatientQueryKno2 extends React.Component {
  render() {
    const { queryKno2 } = this.props;
    return (
      <div>
        <ReactTable
          columns={[
            {
              Header: 'Organization',
              accessor: 'displayName',
            },
            
            {
              Header: 'Address',
              accessor: 'address',
            },
            {
              Header: 'Patient Name',
              accessor: 'name',
            },
            {
              Header: 'DOB',
              accessor: 'creationTime',
              //Cell: (row) => (
              //  <Moment
              //    date={row.original.creationTime}
              //    format="MM/DD/YYYY"
              //  />
              //),
            },
            {
              Header: 'Match%',
              accessor: 'reaction',
            },
          ]}
          className="-striped -highlight"
          //loading={isHealthProfileLoading}
          data={
            queryKno2 
              ? queryKno2.data
              : []
          }
          minRows={2}
          sortable={true}
          defaultSorted={[
            {
              id: 'creationTime',
              desc: true,
            },
            {
              id: 'name',
              asc: true,
            },
          ]}
          PaginationComponent={Pagination}
          showPaginationTop={false}
          pageSize={5}
          freezeWhenExpanded={true}
          filterable
          
        />
          {/*<div className="table-responsive">*/}
          {/*  <table className="table table-bordered table-condensed">*/}
          {/*    <thead>*/}
          {/*      <tr>*/}
          {/*        <th>Organization</th>*/}
          {/*        <th>Address</th>*/}
          {/*        <th>Patient Name</th>*/}
          {/*        <th>DOB</th>*/}
          {/*        <th>Match%</th>*/}
          {/*      </tr>*/}
          {/*    </thead>*/}
          {/*    <tbody>*/}
          {/*      {queryKno2 && queryKno2.data && queryKno2.data.map(q => (*/}
          {/*        <tr key={q.orgId}>*/}
          {/*          <td>{q.displayName}</td>*/}
          {/*          <td>{q.address}</td>*/}
          {/*          <td></td>*/}
          {/*          <td></td>*/}
          {/*          <td>*/}
          {/*            */}{/*{outreach.nextFlowUpAt !== null && (*/}
          {/*            */}{/*  <Moment*/}
          {/*            */}{/*    date={outreach.nextFlowUpAt}*/}
          {/*            */}{/*    format="MM/DD/YYYY"*/}
          {/*            */}{/*  />*/}
          {/*            */}{/*)}*/}
          {/*          </td>*/}
          {/*        </tr>*/}
          {/*      ))}*/}
          {/*    </tbody>*/}
          {/*  </table>*/}
          {/*</div>*/}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/management/components/PatientQueryKno2.js